import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getVisibleSections } from "wasp/client/operations";
import { useLocationContext } from "../contexts/LocationContext";

/**
 * Redirects to dashboard if the given section is hidden (globally or for current location).
 * Use on section list pages (e.g. RetailPage, LostFoundPage).
 */
export function useRequireSectionVisible(sectionKey: string) {
  const navigate = useNavigate();
  const { selectedLocation } = useLocationContext();
  const { data, isLoading } = useQuery(getVisibleSections, {
    locationId: selectedLocation?.id ?? null,
  });
  const visibilityData = data as
    | { visibleByKey?: Record<string, boolean> }
    | undefined;
  const visibleByKey = visibilityData?.visibleByKey ?? {};

  useEffect(() => {
    if (isLoading) return;
    if (visibleByKey[sectionKey] === false) {
      navigate("/dashboard", { replace: true });
    }
  }, [sectionKey, visibleByKey, isLoading, navigate]);
}
